import script from "./TransportationIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportationIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__